import "./ZoomControls.css";

export type ZoomLevel = "fit" | number;

export const ZOOM_STEPS: ZoomLevel[] = ["fit", 0.5, 1.0, 2.0, 4.0];

interface Props {
  zoom: ZoomLevel;
  onChange: (z: ZoomLevel) => void;
}

function zoomLabel(z: ZoomLevel): string {
  return z === "fit" ? "Fit" : `${Math.round(z * 100)}%`;
}

export default function ZoomControls({ zoom, onChange }: Props) {
  const idx = ZOOM_STEPS.indexOf(zoom);
  const dec = () => {
    if (idx > 0) onChange(ZOOM_STEPS[idx - 1]);
  };
  const inc = () => {
    if (idx >= 0 && idx < ZOOM_STEPS.length - 1) onChange(ZOOM_STEPS[idx + 1]);
  };
  return (
    <div className="zoom-controls" role="group" aria-label="Zoom">
      <button
        type="button"
        className="zoom-btn"
        onClick={dec}
        disabled={idx <= 0}
        aria-label="Zoom out"
        title="Zoom out"
      >
        −
      </button>
      <button
        type="button"
        className={`zoom-btn label${zoom === "fit" ? " active" : ""}`}
        onClick={() => onChange("fit")}
        aria-pressed={zoom === "fit"}
        title="Fit to width"
      >
        {zoomLabel(zoom)}
      </button>
      <button
        type="button"
        className="zoom-btn"
        onClick={inc}
        disabled={idx === ZOOM_STEPS.length - 1}
        aria-label="Zoom in"
        title="Zoom in"
      >
        +
      </button>
    </div>
  );
}

/** Compute inline CSS width for a canvas given its natural pixel width and zoom level. */
export function zoomedCanvasStyle(zoom: ZoomLevel, canvasNaturalWidth?: number): React.CSSProperties {
  if (zoom === "fit") {
    return { width: "auto", maxWidth: "100%", height: "auto" };
  }
  if (!canvasNaturalWidth) return { width: "auto", height: "auto" };
  return {
    width: `${Math.round(canvasNaturalWidth * zoom)}px`,
    maxWidth: "none",
    height: "auto",
  };
}
